export const sendmailEndpoints = {
    SENDMAIL_ROUTES: {
        SENDMAIL: '/sendmail',
    },
    BACKEND_SENDMAIL_ROUTES: {
        SENDMAIL: `${process.env.REACT_APP_SERVER_URL}/sendmail`,
    },
};
